import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

require('@/assets/overrides.scss')

const opts = {
  rtl: false,
  theme: {
    // disable: true,
    dark: false,
    light: false,
  }
}

export default new Vuetify(opts)
